<template>
  <div class="c-contact">
    <h1>Inchcape Park</h1>
    <h3>Jesteśmy tu dla Ciebie.</h3>
    <l-map
      ref="map"
      v-model:zoom="zoom"
      :zoom="16"
      :center="cords"
      class="c-contact__map"
    >
      <l-tile-layer
        url="https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png"
        layer-type="base"
        name="OpenStreetMap"
      ></l-tile-layer>
      <l-marker :lat-lng="cords"> </l-marker>
    </l-map>
    <div class="c-contact__row">
      <div class="c-contact__col">
        <h4>SERWIS</h4>
        <p>
          ul. Łopuszańska 38B
          <br />
          02-232 Warszawa
        </p>
        <p>
          tel:+48 22 182 28 22
          <br />
          <a href="mailto:serwis.lopuszanska@jlr-imp.pl">serwis.lopuszanska@jlr-imp.pl</a>
        </p>
        <p>
          poniedziałek - piątek: 9.00 - 19.00
          <br />
          sobota: 09.00 - 16.00
        </p>
      </div>
      <div class="c-contact__col">
        <h4>CZĘŚCI I AKCESORIA</h4>
        <p>
          ul. Łopuszańska 38B
          <br />
          02-232 Warszawa
        </p>
        <p>
          tel:+48 22 182 28 22
          <br />
          <a href="mailto:orders.lopuszanska@jlr-imp.pl">orders.lopuszanska@jlr-imp.pl</a>
        </p>
        <p>
          poniedziałek - piątek: 9.00 - 19.00
          <br />
          sobota: 09.00 - 16.00
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
export default {
  data() {
    return {
      zoom: 14,
      cords: [52.19471197186081, 20.94111754059525],
    };
  },
  components: { LMap, LTileLayer, LMarker },
};
</script>
<style lang="scss">
.c-contact {
  &__map {
    width: 100%;
    min-height: 440px;
    max-height: 50vh;
    margin-top: 3rem;
  }
  &__row {
    padding: 3rem 0;
    @media (min-width: 780px) {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    gap: 1rem;
  }
  &__col {
    width: 100%;
  }
}
</style>
